export const BulkActionBarTestAttributes = {
    primaryButton: 'primaryButton',
    secondaryButton: 'secondaryButton',
    tertiaryButton: 'tertiaryButton',
    moreButton: 'moreButton',
    deselectButton: 'deselectButton',
};
